module.exports = __webpack_public_path__ + "assets/img/dashboard.28a2a850.svg";